// src/components/Hero.js

import React from 'react';
import HeroDoorloopje from './HeroDoorloopje';

// Helper: haal zowel ID als (optionele) privacy hash uit een Vimeo URL
// Voorbeelden die goed gaan:
// - https://vimeo.com/536363871/385f39e525  => id=536363871, hash=385f39e525
// - https://vimeo.com/536363871              => id=536363871, hash=null
function getVimeoIdAndHash(url) {
  if (!url) return {};
  const match = /vimeo\.com\/(\d+)(?:\/([a-z0-9]+))?/i.exec(url);
  if (!match) return {};
  return { id: match[1], hash: match[2] || null };
}

const Hero = ({ data, onLoginClick }) => {
  const heroImageUrl = data.hero_image?.url || '';
  const vimeoUrl = data.vimeo_url || '';
  const { id: vimeoId, hash: vimeoHash } = getVimeoIdAndHash(vimeoUrl);

  // Bouw de embed-URL. Als er een hash is, moet die als ?h=<hash> mee.
  const base = vimeoId ? `https://player.vimeo.com/video/${vimeoId}` : null;
  const params = [
    vimeoHash ? `h=${vimeoHash}` : null,
    'color=ffdd00',
    'title=0',
    'byline=0',
    'portrait=0',
  ]
    .filter(Boolean)
    .join('&');
  const iframeSrc = base ? `${base}?${params}` : null;

  // Fallback als het hexagon-doorloopje niet geladen kan worden:
  // vimeo-video (indien ingesteld), anders een neutrale placeholder.
  const legacyVisual = vimeoId ? (
    <div className="hero-video-content video-container">
      <iframe
        src={iframeSrc}
        width="100%"
        height="100%"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        title={data.title || 'Hero video'}
      ></iframe>
    </div>
  ) : (
    <div
      className="hero-video-placeholder"
      style={{
        width: '100%',
        height: '270px',
        backgroundColor: '#e9ecef',
        borderRadius: '16px',
      }}
    />
  );

  return (
    <div className="hero-content-wrapper">
      <div className="hero-text-content">
        <h1>{data.title}</h1>
        <p>{data.subtitle}</p>
        <a href="/info/wat-zijn-doorloopjes" className="btn-secondary hero-info-btn">
          Wat zijn Doorloopjes?
        </a>
      </div>
      <div className="hero-visual-content">
        {heroImageUrl ? (
          // Optionele CMS-override: als er een hero-afbeelding is geüpload, toon die.
          <img
            src={heroImageUrl}
            alt={data.hero_image?.alternativeText || 'Doorloopje'}
            className="hero-photo"
            style={{
              maxHeight: '420px',
              width: 'auto',
              maxWidth: '100%',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'block',
              margin: '0 auto',
            }}
            onClick={() =>
              onLoginClick &&
              onLoginClick('/dashboard', 'Maak gratis een account aan om dit doorloopje te bekijken.')
            }
          />
        ) : (
          <HeroDoorloopje onLoginClick={onLoginClick} fallback={legacyVisual} />
        )}
      </div>
    </div>
  );
};

export default Hero;
